import React from 'react';
import DonutChart from '../common/DonutChart';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT, toNumberSafe } from '../../utils/format';

const C_ROI    = '#10b981'; // emerald
const C_LEVEL  = '#06b6d4'; // teal
const C_DIRECT = '#34d399'; // mint
const C_PEND   = '#f59e0b'; // amber
const C_CLAIM  = '#64748b'; // slate

export default function IncomeBreakdownCard() {
  const { incomeBreakdown } = useContractState();
  const roi     = incomeBreakdown ? incomeBreakdown.roi          : 0;
  const level   = incomeBreakdown ? incomeBreakdown.levelIncome  : 0;
  const direct  = incomeBreakdown ? incomeBreakdown.directIncome : 0;
  const pending = incomeBreakdown ? incomeBreakdown.pending      : 0;
  const claimed = incomeBreakdown ? incomeBreakdown.claimed      : 0;

  const items = [
    { label: 'Trading Profit', raw: roi,     color: C_ROI },
    { label: 'Level Income',   raw: level,   color: C_LEVEL },
    { label: 'Direct Income',  raw: direct,  color: C_DIRECT },
    { label: 'Pending',        raw: pending, color: C_PEND },
    { label: 'Claimed',        raw: claimed, color: C_CLAIM }
  ];
  const chartData = items.map(it => ({ label: it.label, value: toNumberSafe(it.raw), color: it.color }));
  const total = chartData.reduce((a, b) => a + b.value, 0);

  return (
    <div className="card income-card">
      <div className="head">
        <h3>Income Breakdown</h3>
        <div className="total">{formatUSDT(incomeBreakdown ? incomeBreakdown.totalEarnedOut : 0)}</div>
      </div>
      <div className="donut-wrap">
        <DonutChart
          data={chartData}
          centerLabel={total > 0 ? '100%' : '—'}
          centerSub="LIFETIME"
        />
        <div className="legend">
          {items.map((it, i) => (
            <div key={i} className="legend-item">
              <span className="k"><span className="dot" style={{ background: it.color }} />{it.label}</span>
              <span className="v">{formatUSDT(it.raw)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
